import React, { useEffect, useState } from "react"
import Loader from "../ux/loader"

export const shouldUpdateScroll = () => {
  return false
}

const RootWrapper = ({ children }) => {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (typeof window === "undefined" || typeof document === "undefined") return
    window.scrollTo({ top: 0, behavior: "instant" }) // comportamento instantâneo

    const handleLoad = () => {
      setLoading(false)
    }

    if (document.readyState === "complete") {
      handleLoad()
    } else {
      window.addEventListener("load", handleLoad)
      return () => window.removeEventListener("load", handleLoad)
    }
  }, [])

  return (
    <>
      {loading && <Loader />}
      {children}
    </>
  )
}

export default RootWrapper
